import angular from 'angular';
import DateTimeHelper from "./DateTimeHelper";

let utilsModule = angular.module('utils', [])

  .service('dateTimeHelper', DateTimeHelper);

export default utilsModule;



// WEBPACK FOOTER //
// ./client/app/common/utils/utils.js